module.exports = __webpack_public_path__ + "static/media/aris.f8692554.jpg";